import { render, staticRenderFns } from "./groupContent.vue?vue&type=template&id=31a05d30&scoped=true"
import script from "./groupContent.vue?vue&type=script&lang=js"
export * from "./groupContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a05d30",
  null
  
)

export default component.exports